import { getAuthAxiosBackend } from "@/helpers/axios"

class MartyrDataServices{

    get(id){
        return getAuthAxiosBackend().get('MartyrData/getMartyrData/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('MartyrData/getMartyrDataByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('MartyrData/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('MartyrData/addMartyrData', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('MartyrData/updateMartyrData/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('MartyrData/softDeleteMartyrData/' + id.toString())
    }
}

export default new MartyrDataServices()